import { FEATURE_FLAGS_ACTIONS } from './featureFlags.types';
export const setFeatureFlagsAction = (payload) => ({
    type: FEATURE_FLAGS_ACTIONS.SET_FLAGS,
    payload
});
export const setFeatureFlagAction = (payload) => ({
    type: FEATURE_FLAGS_ACTIONS.SET_FLAG,
    payload
});
export const setFeatureFlagsStatusAction = (payload) => ({
    type: FEATURE_FLAGS_ACTIONS.SET_STATUS,
    payload
});
export const setFeatureFlagCurrentStatusAction = (payload) => ({
    type: FEATURE_FLAGS_ACTIONS.SET_CURRENT_STATUS,
    payload
});
export const setFeatureFlagsErrorsAction = (payload) => ({
    type: FEATURE_FLAGS_ACTIONS.SET_ERRORS,
    payload
});
export const clearFeatureFlagsErrorsAction = () => ({
    type: FEATURE_FLAGS_ACTIONS.CLEAR_ERRORS
});
export const clearFeatureFlagsAction = () => ({
    type: FEATURE_FLAGS_ACTIONS.CLEAR_FLAGS
});
export const clearFeatureFlagCurrentAction = () => ({
    type: FEATURE_FLAGS_ACTIONS.CLEAR_CURRENT
});
